import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type MetricResult = {
  group_by: string | null
  value: number | null
  // Optional timing metadata for time series data
  timestampStart?: number
  timestampEnd?: number
  timeIndex?: number
}

export interface MetricDataState {
  data: { [k: string]: MetricResult[] };
  isLoading: boolean;
  error: string | null;
}
const metricDataInitialState: MetricDataState = {
  data: {},
  isLoading: false,
  error: null
};

export const metricDataSlice = createSlice({
  name: 'metricData',
  initialState: metricDataInitialState,
  reducers: {
    updateMetricData: (state, action: PayloadAction<{ [k: string]: MetricResult[] }>) => {
      state.data = { ...state.data, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetMetricData: (state) => {
      state.data = {};
    }
  }
});

export const { updateMetricData, setLoading, setError, resetMetricData } = metricDataSlice.actions;

export interface AnalyticsResetTimer { reset: number }
const analyticsResetTimerInitialState: AnalyticsResetTimer = { reset: 0 }

export const analyticsResetTimerSlice = createSlice({
  name: 'analyticsResetTimer',
  initialState: analyticsResetTimerInitialState,
  reducers: {
    setReset: (state) => { state.reset += 1 }
  }
});

export const { setReset } = analyticsResetTimerSlice.actions;

